var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTagErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.30039 0.175585C9.16974 -0.0585283 8.83152 -0.0585283 8.70087 0.175585L0.710943 14.4928C0.583966 14.7204 0.749236 15 1.0107 15H16.9906C17.252 15 17.4173 14.7204 17.2903 14.4928L9.30039 0.175585ZM8.09894 10.4997V5H9.90449V10.4997H8.09894ZM8.99998 13.8333C8.40167 13.8333 7.91665 13.3483 7.91665 12.75C7.91665 12.1517 8.40167 11.6667 8.99998 11.6667C9.59829 11.6667 10.0833 12.1517 10.0833 12.75C10.0833 13.3483 9.59829 13.8333 8.99998 13.8333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagErrorIcon);
export default __webpack_public_path__ + "static/media/tag-error-icon.75e95ecd32250bac48e97bedcf5907e7.svg";
export { ForwardRef as ReactComponent };